import PropTypes from 'prop-types';
import React, { createContext, useContext, useReducer } from 'react';

import ContatosActionTypes from './reducers/Contatos/actions';
import { CONTATO_INICIAL, ContatosReducer } from './reducers/Contatos/reducer';

export const ContatosContext = createContext();

export function useContatosContext() {
  const context = useContext(ContatosContext);
  return context;
}

export default function ContatosProvider({ children }) {
  const [contatos, dispatch] = useReducer(ContatosReducer, CONTATO_INICIAL);

  const setContatosAction = contatosList => {
    dispatch({ type: ContatosActionTypes.SET_CONTATOS, payload: contatosList });
  };

  const removeContatoAction = contato => {
    dispatch({ type: ContatosActionTypes.REMOVE_CONTATO, payload: contato });
  };

  const addContatoAction = contato => {
    dispatch({ type: ContatosActionTypes.ADD_CONTATO, payload: contato });
  };

  const clearContatosAction = () => {
    dispatch({ type: ContatosActionTypes.CLEAR_CONTATOS });
  };

  return (
    <ContatosContext.Provider
      value={{
        contatos,
        setContatosAction,
        removeContatoAction,
        addContatoAction,
        clearContatosAction,
        dispatch,
      }}
    >
      {children}
    </ContatosContext.Provider>
  );
}

ContatosProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ContatosContext.displayName = 'ContatosContext';
